/* eslint-disable @typescript-eslint/naming-convention */
import type { IService } from '../../shared';
import { EventGenerator } from '../events';
import type { ServiceManager } from '../service-manager';

/** 将模糊半径转换为画布 CSS filter */
export const getCanvasBlurFilter = (blur: number) =>
    Number.isFinite(blur) && blur > 0 ? `blur(${blur}px)` : undefined;

/** 画布模糊服务 */
export class BlurService implements IService {
    constructor(readonly service: ServiceManager) {
        new EventGenerator('blur', this, service);
    }

    onInit() {
        this.setBlur(0);
    }

    /** 画布模糊半径，单位为 px */
    readonly blur = 0;
    declare getBlur: () => number;
    declare setBlur: (blur: number) => void;
    declare onBlurChange: (fn: (blur: number) => void) => number;
}
